import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { ExportgridComponent } from '../../grid/exportgrid/exportgrid.component';
import { ReportfilterComponent } from '../../grid/reportfilter/reportfilter.component';

@Component({
  selector: 'app-attendancesummaryreport',
  templateUrl: './attendancesummaryreport.component.html',
  styleUrls: ['./attendancesummaryreport.component.css']
})
export class AttendancesummaryreportComponent implements OnInit {

  @ViewChild('filterbar',{static:false}) filterbar;

  isadd:boolean=false;
  isedit:boolean=false;
  isdelete:boolean=false;
  isview:boolean=false;
  isprint:boolean=false;
  isexport: boolean = false;
  isfilter: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  formname: string = "InsuranceReport";

  filterempid: any = 0;
  filterempname: any = "";
  fromdate: any = new Date();
  todate: any = new Date();

  filterstatus: string = ""; 
  dtOptions: DataTables.Settings = {};
    
  attendanceColl: any = [];
  filterstatusColl:any=[];
 
 

  searchtxt: any = "";

  columnDefs = [
    { headerName: 'Employee', field: 'empname' },     
    { headerName: 'Staffcode', field: 'staffcode' },     
    { headerName: 'AttendanceNo', field: 'attendanceno' },     
    { headerName: 'Date', field: 'logdate', type:'date'},   
    { headerName: 'Work Status', field: 'shortworkstatus' },         
 
  ]

  gridOptions = {
    enableactioncol: false,
    columnDefs: this.columnDefs,
  };

  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor( private appService:AppdataService,private loginService:LoginserviceService,public router: Router,private route: ActivatedRoute,
    private confirmationDialogService: ConfirmationDialogService,private toastr: ToastrService,private datePipe: DatePipe, private productFindService: NgbModal) {
      this.fnServiceChanges();

      this.dateCustomClasses = [
        { date: new Date(), classes: ['bg-warning'] },
      ];
      this.fromdate.setDate(this.fromdate.getDate() - 15);
  }
  
  //Company Check
  fnServiceChanges(){
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading=true;
          this.fnOnInitForm();
        }
        else{
          this.fnUserFailedForm();
        }   
        
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }
  
  //Init
  ngOnInit() {
    try{
      if(this.loginService.fnCheckCompany()){         
        this.fnCheckPrivilage();
        if(this.isview){
          this.isloading=true;
          this.fnOnInitForm();
        }
        else{
          this.fnUserFailedForm();
        }          
      }
      else{
        this.loginService.fnGetUserRoleList();
      } 
    }catch(ex){
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    this.fromdate.setDate(this.fromdate.getDate() - 30);

    this.fnGetFilterStaus();
    this.fngetAttendanceReport();     
  }


  fnCheckPrivilage() {
    
    this.isadd=this.loginService.fnCheckUserRoleAction(this.formname,'CREATE');
    this.isedit=this.loginService.fnCheckUserRoleAction(this.formname,'ALTER');
    this.isdelete=this.loginService.fnCheckUserRoleAction(this.formname,'DELETE');
    this.isview=this.loginService.fnCheckUserRoleAction(this.formname,'VIEW');
    this.isprint=this.loginService.fnCheckUserRoleAction(this.formname,'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');
    
    
  }

  fnUserFailedForm(){
    this.isprivilage=true;
  }

  fnGetFilterStaus() {
    this.filterstatusColl = []
    this.filterstatusColl.push({'displayname':'Preasent','value':'PREASENT'})
    this.filterstatusColl.push({'displayname':'Absent','value':'ABSENT'})
    this.filterstatusColl.push({ 'displayname': 'Holidays', 'value': 'HOLIDAYS' })
    this.filterstatusColl.push({'displayname':'Leave','value':'LEAVE'})    
    
  }
 
  fnActionExportClick()  {
      const params = {
        columnGroups: true,
        allColumns: true,
        fileName: 'Insurancelist',
        //columnSeparator: document.querySelector("#columnSeparator").value
      };
    //  this.gridApi.exportDataAsCsv(params);
  }
  fnActionFilterClick() {  

    // this.filterbar.filterstatus = this.filterstatus;
    
    // this.isfilter = !this.isfilter;
    this.fnShowFilterPopup();
  }

  fnActionRefreshClick() { 
    this.fngetAttendanceReport()
  }
  fnApplyFilterPop(data) {
    // this.isfilter = !this.isfilter;


    this.filterempid = data.empid;
    this.filterempname = data.empname;
  

    this.fngetAttendanceReport();

  }
  fnApplyFilter(data) {
    //this.isfilter = !this.isfilter;

    this.filterstatus = data;

    this.fngetAttendanceReport();

  }
 

  fnCurrentRouteChange() { 
    var queryParams = {};
    

    if (this.filterstatus != '') {     
      queryParams['status'] = this.filterstatus;
    }   

     this.router.navigate(
      [], 
      {
        relativeTo: this.route,
        queryParams: queryParams, 
      
      });
  }
  
  fnRemoveFilter(type) {
    
    if(type==='INACTIVE'){
      this.filterstatus="";
      this.fngetAttendanceReport();     
    }  
    else{
      this.filterstatus="";
      this.fngetAttendanceReport();    
    }
  }

  //Get
  fngetAttendanceReport() {
    if(this.showProgress){
      return;
    }

    this.fnShowProgress();     
      var data = {
        'insuranceid': 0,
        'empid': this.filterempid,
          'companyid': this.loginService.fnGetCompanyId(),
          'filterstatus':this.filterstatus     ,                                                                      
          'fromdate': this.fnFormatDatetime(this.fromdate),
          'todate': this.fnFormatDatetime(this.todate),
      }
      this.appService.getAttendanceSummaryReport(data)
      .subscribe(
          (res)=>{                  
            if(res.json().status===200){
              this.fnHideProgress();                   

              this.attendanceColl = res.json().result; 
              

              this.columnDefs = this.generateColumns(this.attendanceColl);

                this.fnSetTable(); 
                this.fnCurrentRouteChange();                     
    
            }else {
              this.fnHideProgress();                   

                this.loginService.fnAPIError(res.json())
            }             
          },
          (err)=>{ 
            this.fnHideProgress();                   
         
              this.toastr.error('Error', err);
      })
  }

  generateColumns(data: any[]) {
    let columnDefinitions = [];

    data.map(object => {

      Object
        .keys(object)
        .map(key => {

          let mappedColumn = {
            headerName: key.toUpperCase(),
            field: key,
            pinned: key.toUpperCase() == 'EMPLOYEE' || key.toUpperCase() == 'CODE' ? 'left' : key.toUpperCase() == 'TOTAL SALARY' ? 'right' : '',
            width: key.toUpperCase() == 'EMPLOYEE' ? 260 : 150,
            minWidth: 150,
            valueFormatter: key.toUpperCase() != 'EMPLOYEE' && key.toUpperCase() != 'PAID DAYS' && key.toUpperCase() != 'CODE' ? '': ''
          }

          if (key != 'empid') {
            columnDefinitions.push(mappedColumn);
          }

        })
    })
    //Remove duplicate columns
    columnDefinitions = columnDefinitions.filter((column, index, self) =>
      index === self.findIndex((colAtIndex) => (
        colAtIndex.field === column.field
      ))
    )
    return columnDefinitions;
  }

  fnShowFilterPopup() {

    const modalRef = this.productFindService.open(ReportfilterComponent, { size: <any>'xl' });
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.empid = Number(this.filterempid);
    // modalRef.componentInstance.fromdate = this.filterfromdate;
    // modalRef.componentInstance.todate = this.filtertodate;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      console.log(receivedEntry)

      if (receivedEntry.status === 'DONE') {
        this.filterempid = receivedEntry.empid;
        this.filterempname = receivedEntry.empname;
       
        this.fngetAttendanceReport();
      }


    });
  }
  


  fnCloseForm(){
    try{
      this.router.navigate(['/Reports']);
    }catch(ex){
       this.fnShowErrorMsg(ex);
    }
    }



  fnSetTable() {
 
  }

  public fnSearchDatatable(value){    
  
  }

  private fnFocusTableRow(index,status){
    if(index>-1){
      if(status==='IN'){          
        this.attendanceColl[index].hoverfocus="IN"
      }
      else{
        this.attendanceColl[index].hoverfocus=""
      }                
    }    
  }
  fnMomentDateFormatter(params) {
    if (params.value) {
      return moment(params.value).format('DD-MM-YYYY');//  
    }
    else {
      return '';
    }
  
  }

  fnMomentTimeFormatter(params) {
    if (params.value) {
      return moment(params.value).format('hh:mm');//  
    }
    else {
      return '';
    }
  
  }
  fnFormatDatetime(dt){
    if(dt){
      if(dt===""){
        return null
      }
      else{
        return this.datePipe.transform(dt,"yyyy-MM-dd")  
      }
      
      }else {
      return null
    }
    
  }
  private fnExport() {

    const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'xxl', backdrop: 'static' });
    modalRef.componentInstance.doctype = this.formname;
    modalRef.componentInstance.columnDefs = this.columnDefs;
    modalRef.componentInstance.contentColl = this.attendanceColl;
    modalRef.componentInstance.fnSetTable();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
  
    
    });
  
  }
fnInsertActivityLog(action,refno,desc){
  try{
    var data={
      logtype:action,
      logat:this.formname,
      refnum:refno,
      logdescr:desc,companyid: this.loginService.fnGetCompanyId(),         
      logby:this.loginService.fnGetModUserId(),
    }
  

    this.appService.fnInsertActivity(data).subscribe(
      (res)=>{
      },
      (err)=>{
     
      });

  }catch{

  }
}
private fnShowProgress() {
  this.showProgress = true;
}
private fnHideProgress() {
  this.showProgress = false;
}

  private  fnShowErrorMsg(ex){
    this.toastr.warning('Internal Error', ex);       
  }











}
